import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const NoEquipmentGlyph = /*#__PURE__*/createElement("g", {
  id: "no_equipment"
}, /*#__PURE__*/createElement("ellipse", {
  cx: "18.4",
  cy: "66.6",
  rx: "9.1",
  ry: "1.9"
}), /*#__PURE__*/createElement("ellipse", {
  cx: "42",
  cy: "66.6",
  rx: "9.1",
  ry: "1.9"
}), /*#__PURE__*/createElement("ellipse", {
  cx: "65.6",
  cy: "66.6",
  rx: "9.1",
  ry: "1.9"
}), /*#__PURE__*/createElement("path", {
  d: "M43.5,45.9v-6.6h9.1c1.2,0,2.1-1,2.1-2.1V23.7c0-1.2-1-2.1-2.1-2.1H31.4c-1.2,0-2.1,1-2.1,2.1v13.5c0,1.2,1,2.1,2.1,2.1 h9.1v6.6c-12.3,0.3-21.7,5.7-21.7,12.4c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5c0-4.9,8.5-9.1,18.7-9.4V58c0,0.8,0.7,1.5,1.5,1.5 s1.5-0.7,1.5-1.5v-9.1c10.3,0.3,18.7,4.5,18.7,9.4c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5C65.2,51.6,55.8,46.2,43.5,45.9z M32.2,24.6h19.5v11.8H32.2V24.6z"
}));
const NoEquipment = createSvg({
  name: 'no_equipment',
  path: NoEquipmentGlyph
});

export default NoEquipment;
export { NoEquipmentGlyph };
